import React from "react";

const FahYellow = (props) => {
  return (
    <div className="mt-4">
      <div
        className="w-100 flex gap-3 border py-2 border-gray-100 bg-[#feff27]"
        // style={{ backgroundColor: props.backgroundColor }}
      >
        <div className="w-full m-auto text-center">
          <img className="m-auto w-40 h-10" src={require("../../../assets/instatags.png")} />
        </div>
        <div className="w-full text-center">
          <p className="mb-0" style={{ color: props.priceColor }}>
            <span className="text-3xl relative -top-5 font-[1000]">$</span>
            <span className="text-6xl font-[1000]">4 99</span>
            <br />
          </p>
          <p className="font-bold mb-0" style={{ color: props.priceColor }}>
            4pk 16oz Cans
          </p>
          <p className="text-[10px] text-slate-500 mb-0">+ TAX & DEPOSIT</p>
        </div>
      </div>
    </div>
  );
};

export default FahYellow;
